module.exports = __webpack_public_path__ + "static/media/Nirmal-Gram-Purskar-Pratik-Patil-Appriciation-letter.2781bf04.jpeg";